import React, { Fragment, useState, useEffect } from 'react';
import PropTypes from 'prop-types';

// Redux
import { connect } from 'react-redux';

// Actions
import { setAlert } from '../../../../actions/alertActions';
import { toggleCreateGroupModal, goBack } from '../../../../actions/navActions';

// Switch Pages
import AddPhoto from './AddPhoto';
import AddDescription from './AddDescription';

// Icons
import CloseOutlinedIcon from '@material-ui/icons/CloseOutlined';
import AddName from './AddName';
import AddPrivacy from './AddPrivacy';
import { createGroup } from '../../../../actions/groupActions';
import AddTags from './AddTags';


// Initial State 
const initialState = {
    group_name: '',
    description: '',
    relevant_keywords: '',
    location: null
};

const CreateGroupSlidingForm = ({ 
    auth, 
    setAlert,
    toggleCreateGroupModal,
    goBack,
    page,
    previousUrl,
    history,
    post,
    is_create_page,
    createGroup
}) => {

    // Form Data state and setter
    const [formData, setFormData] = useState(initialState);
    const [privacy, setPrivacy] = useState(null);
    const [groupImg, setGroupImg] = useState(null);

    const [processing, setProcessing] = useState(false);

    // State variables for form transitions
    const [slideform1, setSlideForm1] = useState(false);
    const [slideform2, setSlideForm2] = useState(false);
    const [slideform3, setSlideForm3] = useState(false);
    const [slideform4, setSlideForm4] = useState(false);
    const [slideform5, setSlideForm5] = useState(false);
    const [slideform6, setSlideForm6] = useState(false);

    useEffect(() => {
        // Load profile data
        if (!auth.loading && auth.user) {
            const profileData = { ...initialState };
            for (const key in auth.user) {
                if (key in profileData) profileData[key] = auth.user[key];
            }

            setFormData(profileData);
        }
    }, [auth.user]);

    // --- Edit profile info logic ---

    const { group_name, description, location, relevant_keywords } = formData;

    // Form input change handler
    const onChange = e => setFormData({ ...formData, [e.target.name]: e.target.value});

    // Triggered when the bio form is submitted
    // const bioTodo = (e) => {
    //     onSubmitBio(e);
    // }

    const handleGoBack = (e) => {
        e.preventDefault();
        toggleCreateGroupModal();
        setFormData(initialState);
        if(page) {
            if(previousUrl !== null) {
                if(previousUrl === 'create' || previousUrl === 'create_home') {
                    history.push(`/create/post?goBack=home`);
                } else if(previousUrl === 'create_detail') {
                    history.push(`/create/post?goBack=detail`);
                } else if(previousUrl === 'create_profile') {
                    history.push(`/create/post?goBack=profile`);
                } else if(previousUrl === 'comment') {
                    if(post) {
                        history.push(`/create/comment/${post._id}`);
                    } else {
                        goBack();
                    }
                } else {
                    history.push(`/${previousUrl}`);
                }
            } 
        }
    }

    const handleSubmit = async () => {
        setProcessing(true);
        try {
            await createGroup({name: group_name, description, privacy, user: auth.user, relevant_keywords}, groupImg);
            // will redirect to group page if function is successful
        } catch (error) {
            console.log("Error - Failed trying to create group"); 
            console.log(error);
            setProcessing(false);
            setAlert('Something went wrong!');
        }
    }

    return (
        <Fragment>
            {/* Render close button if on full categoryPage for mobile */}
            {!is_create_page && (
                <div onClick={handleGoBack} style={{margin: '20px'}} className="form__backBtn right">
                    <CloseOutlinedIcon />
                </div>
            )}
            <div style={{width:'100%'}} className="form-transition">

                {/* Add Photo Form */}
                <div id="transition-1" style={{width:'100%'}} className={!slideform1 ? "auth-form-container active" : "auth-form-container"}>
                    <AddName is_create_page={is_create_page} slideform1={slideform1} setSlideForm1={setSlideForm1} formData={formData} onChange={onChange} handleGoBack={handleGoBack} />
                </div>

                <div id="transition-2" style={{width:'100%'}} className={slideform1 ? "auth-form-container active" : "auth-form-container"}>
                    <div style={{width:'100%'}} className="form-transition">

                        {/* Add Bio Form */}
                        <div id="transition-1" style={{width:'100%'}} className={!slideform2 ? "auth-form-container active" : "auth-form-container"}>
                            <AddPrivacy is_create_page={is_create_page} slideform1={slideform1} setSlideForm1={setSlideForm1} slideform2={slideform2} setSlideForm2={setSlideForm2} privacy={privacy} setPrivacy={setPrivacy} />
                        </div>

                        {/* Confirmation Slide - no inputs or actions here */}
                        <div id="transition-2" style={{width:'100%'}} className={slideform2 ? "auth-form-container active" : "auth-form-container"}>
                            <div style={{width:'100%'}} className="form-transition">

                                {/* Add Bio Form */}
                                <div id="transition-1" style={{width:'100%'}} className={!slideform3 ? "auth-form-container active" : "auth-form-container"}>
                                    <AddDescription is_create_page={is_create_page} slideform2={slideform2} setSlideForm2={setSlideForm2} slideform3={slideform3} setSlideForm3={setSlideForm3} formData={formData} onChange={onChange} />
                                </div>

                                {/* Confirmation Slide - no inputs or actions here */}
                                <div id="transition-2" style={{width:'100%'}} className={slideform3 ? "auth-form-container active" : "auth-form-container"}>
                                    <div style={{width:'100%'}} className="form-transition">

                                        {/* Add Bio Form */}
                                        <div id="transition-1" style={{width:'100%'}} className={!slideform4 ? "auth-form-container active" : "auth-form-container"}>
                                            <AddPhoto is_create_page={is_create_page} slideform3={slideform3} setSlideForm3={setSlideForm3} slideform4={slideform4} setSlideForm4={setSlideForm4} setGroupImg={setGroupImg} setAlert={setAlert} processing={processing} />
                                        </div>

                                        {/* Confirmation Slide - no inputs or actions here */}
                                        <div id="transition-2" style={{width:'100%'}} className={slideform4 ? "auth-form-container active" : "auth-form-container"}>
                                            <AddTags is_create_page={is_create_page} handleSubmit={handleSubmit} slideform4={slideform4} setSlideForm4={setSlideForm4} formData={formData} onChange={onChange} processing={processing} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                
            </div>
        </Fragment>
    )
}

CreateGroupSlidingForm.propTypes = {
    // Prop type validation for authentication
    auth: PropTypes.object.isRequired,
    setAlert: PropTypes.func.isRequired,
    toggleCreateGroupModal: PropTypes.func.isRequired,
    goBack: PropTypes.func.isRequired,
    createGroup: PropTypes.func.isRequired,
}

const mapStateToProps = state => ({
    
    // Mapping the authentication state
    auth: state.auth
});

export default connect(mapStateToProps, { 

    // Connecting actions to the component
    setAlert,
    toggleCreateGroupModal,
    goBack,
    createGroup
})(CreateGroupSlidingForm);
